import React from 'react';

interface AlertProps {
    children: React.ReactNode;
    variant?: 'default' | 'warning' | 'success' | 'error';
    className?: string;
    onClick?: () => void;
}

const getVariantStyles = (variant: AlertProps['variant']) => {
    switch (variant) {
        case 'success':
            return 'bg-green-50 border-green-200';
        case 'warning':
            return 'bg-yellow-50 border-yellow-200';
        case 'error':
            return 'bg-red-50 border-red-200';
        default:
            return 'bg-blue-50 border-blue-200';
    }
};

const Alert = ({
    children,
    variant = 'default',
    className = '',
    onClick,
}: AlertProps) => {
    const baseClasses = 'alert';
    const variantClasses = getVariantStyles(variant);
    const allClasses = `${baseClasses} ${variantClasses} ${className}`.trim();

    return (
        <div
            role="alert"
            onClick={onClick}
            className={allClasses}
        >
            {children}
        </div>
    );
};

export default Alert;